// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.101.3/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.101.3/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `table.dataTable {
}

table.dataTable td, table.dataTable th {
	padding: 0.4em;
}

table.dataTable th.nowrap, table.dataTable td.nowrap {
	white-space: nowrap;
}

table.dataTable td.wrapall {
	overflow-wrap: break-word;
	word-break: break-all;
}

table.dataTable tr {
	/* border-bottom: 1px solid #444; */
}

table.dataTable tr:hover {
	background-color: #00000020;
}

table.dataTable tr.header {
	background-color: #00000040;
}

table.dataTable tr.tableTools {
	background-color: #00000000;
}

`, "",{"version":3,"sources":["webpack://./src/components/DataTable.css"],"names":[],"mappings":"AAAA;AACA;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,yBAAyB;CACzB,qBAAqB;AACtB;;AAEA;CACC,mCAAmC;AACpC;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B","sourcesContent":["table.dataTable {\n}\n\ntable.dataTable td, table.dataTable th {\n\tpadding: 0.4em;\n}\n\ntable.dataTable th.nowrap, table.dataTable td.nowrap {\n\twhite-space: nowrap;\n}\n\ntable.dataTable td.wrapall {\n\toverflow-wrap: break-word;\n\tword-break: break-all;\n}\n\ntable.dataTable tr {\n\t/* border-bottom: 1px solid #444; */\n}\n\ntable.dataTable tr:hover {\n\tbackground-color: #00000020;\n}\n\ntable.dataTable tr.header {\n\tbackground-color: #00000040;\n}\n\ntable.dataTable tr.tableTools {\n\tbackground-color: #00000000;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
